import React, { useEffect } from 'react';
//import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

import { useLanguage, isInternalChange } from '../Contexts/LanguageContext';
import { useSharedData } from '../Contexts/SharedContext';

import IframePage from './IframePage';
import ExhibitionPage from './ExhibitionPage';


const ExhbitionResolverPage = () => {
    const { slug } = useParams();
    const { language, isInternalChange } = useLanguage();
    const { content } = useSharedData();

    // data is guideteaser node if successful. otherwise null
    const data = resolveDataFromSlug(slug, content, language);
    
    if (!data) {
        // do something sensible here
        return null;
    }

    // iframSrc is null or object with translations
    const isIFrameGuide = data?.iframeSrc ?? false;

    return (
        isIFrameGuide ? <IframePage data={ data } language={ language } isInternalLanguageChange={ isInternalChange } /> : <ExhibitionPage />
    );
}

export default ExhbitionResolverPage;

/**
 * Gets teaserdata from apicontent for given slug
 */
const resolveDataFromSlug = (slug, content) => {
    if (!slug || !content) {
        return null;
    }

    const teasers = content?.guideTeasers?.items || [];
    const matchedTeaser = teasers.find((teaser) => teaser.slug === slug);

    if (!matchedTeaser) {
        console.warn(`No data found for slug: ${slug}`);
        return null;
    }

    return matchedTeaser;
}